<template>
  <div>
    <Layout/>
    <h4>Módulos</h4>
<!-- Master -->
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idModulo" class="form-label">IdModulo</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idModulo" name="idModulo" v-model="datoModulo.idModulo" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="nombre" class="form-label">Nombre</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="nombre" name="nombre" v-model="datoModulo.nombre" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" @click.prevent="cerrarModulo" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
        <button type="submit" class="btn btn-light" @click.prevent="guardarModulo" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditModulo" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>

<!-- Details -->
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">IdModuUsua</th>
          <th scope="col">IdUsuario</th>
          <th scope="col">IdModulo</th>
          <th scope="col">IdRol</th>
          <th scope="col">Estado</th>
          <th scope="col">ModuloNombre</th>
          <th scope="col">UsuarioNombre</th>
          <th scope="col">RolNombre</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="moduusua in datosPaginados" :key="moduusua.idModuUsua">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(moduusua.idModuUsua)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(moduusua.idModuUsua)" title="Editar">edit_square</i></td>
          <td>{{moduusua.idModuUsua}}</td>
          <td>{{moduusua.idUsuario}}</td>
          <td>{{moduusua.idModulo}}</td>
          <td>{{moduusua.idRol}}</td>
          <td>{{moduusua.estado}}</td>
          <td>{{moduusua.moduloNombre}}</td>
          <td>{{moduusua.usuarioNombre}}</td>
          <td>{{moduusua.rolNombre}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteModulo(moduusua.idModuUsua)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar_det">
              <div class="row">
                <div class="col-2">
                  <label for="idModuUsua" class="form-label">IdModuUsua</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idModuUsua" name="idModuUsua" v-model="datoModuUsua.idModuUsua" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idUsuario" class="form-label">IdUsuario</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idUsuario" name="idUsuario" v-model="datoModuUsua.idUsuario" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idModulo" class="form-label">IdModulo</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idModulo" name="idModulo" v-model="datoModuUsua.idModulo" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <input type="hidden" class="form-control" id="idRol" name="idRol" v-model="datoModuUsua.idRol"
                disabled>
                <div class="row">
                  <div class="col-2">
                    <label for="idRol" class="form-label"> Rol</label>
                  </div>
                  <div class="col-9">
                    <input type="text" class="form-control" id="rol" name="rol" v-model="datoModuUsua.rol" disabled>
                  </div>
                  <div class="col-1">
                    <button type="button" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ModalRolLOV"
                      title="Buscar Roles de Usuarios">
                      <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">manage_search</i>
                    </button>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarModuUsua" v-if="btnCrear_det" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditModuUsua" v-if="btnEditar_det" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Details -->

<!--
Listas de valores master
-->
<!--
Listas de valores master
-->
<!--
Listas de valores details
-->
<!-- Lista de Valores: ModuUsua -->
    <ModuUsuaLOVdet @DatosModuUsua="GetDataModuUsuaLOVdet($event)"/>
<!-- Lista de Valores: Rol -->
    <RolLOVdet @DatosRol="GetDataRolLOVdet($event)"/>
<!--
Listas de valores details
-->
    <Footer/>
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
// Listas de valores master
// Listas de valores master
// Listas de valores details
import ModuUsuaLOVdet from '../../components/lovs/ModuUsuaLOV.vue'
import RolLOVdet from '../../components/lovs/RolLOV.vue'
// Listas de valores details
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Layout, Footer
// Listas de valores master
// Listas de valores master
// Listas de valores details
, ModuUsuaLOVdet
, RolLOVdet
// Listas de valores details
  },
  data () {
    return {
// Variables master
      modulos : [],
      datoModulo : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      p_idModulo: '',
// Variables master
// Variables details
      moduusuas : [],
      datoModuUsua : {},
      nombreBusqueda_det: '',
      titulo_det: '',
      btnCrear_det: false,
      btnEditar_det: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true
// Variables details
    }
  },
  mounted () {
    this.p_idModulo = this.$route.params.p_idmodulo
    this.abrirEditar(this.p_idModulo)
    this.getModuUsuas()
    this.getDataPagina(this.paginaActual)
  },
  methods : {
// Procedimientos master
    validarForm(){
      if(this.datoModulo.idModulo === ''){
        swal("Error!", "El elemento idModulo no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoModulo.nombre === ''){
        swal("Error!", "El elemento nombre no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoModulo.estado === ''){
        swal("Error!", "El elemento estado no puede ser nulo.", "error");
        return 0;
      }
      return 1;
    },
    async guardarModulo(){
      if(this.validarForm() === 1){
        try {
          await api.post('/modulos', this.datoModulo)
          swal("Correcto!", "Modulo creada exitosamente!", "success");
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditModulo(){
      if(this.validarForm() === 1){
        try {
          await api.post('/modulos', this.datoModulo)
          swal("Correcto!", "Modulo creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirCrear(){
      this.modalWindow = true
      this.datoModulo={}
      this.titulo   = 'Crear Módulos'
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirEditar(idModulo){
      this.modalWindow = true
      if(idModulo != null){    
           api.get('/vwmodulos/'+idModulo).then(resp=>{
          this.datoModulo = resp.data;
           });
      }
      this.titulo   = 'Editar Módulos'
      this.btnCrear = false
      this.btnEditar= true
    },
    cerrarModulo(){
      this.$router.push('/Modulo')
    },
// Procedimientos master
// Procedimientos detalle
    async getModuUsuas() {
      const resp = await api.get('/moduusuas')
      this.moduusuas = resp.data
    },
    totalPaginas(){
      return Math.ceil(this.moduusuas.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwmoduusuas/nombre/'+this.nombreBusqueda).then(response=>{
          this.moduusuas=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.moduusuas.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwmoduusuas').then(response=>{
      this.moduusuas=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.moduusuas.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarFormDet(){
      if(this.datoModuUsua.idModulo === ''){
        swal("Error!", "El elemento idModulo no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoModuUsua.nombre === ''){
        swal("Error!", "El elemento nombre no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoModuUsua.estado === ''){
        swal("Error!", "El elemento estado no puede ser nulo.", "error");
        return 0;
      }
      return 1;
    },
    async guardarModuUsua(){
      if(this.validarForm() === 1){
        try {
          this.datoModuUsua.idModulo = this.datoModulo.idModulo;
          await api.post('/moduusuas', this.datoModuUsua)
          this.getModuUsuas();
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "ModuUsua creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditModuUsua(){
      if(this.validarForm() === 1){
        try {
          await api.post('/moduusuas', this.datoModuUsua)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "ModuUsua creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoModuUsua={}
      this.titulo   = 'Crear Módulos'
      this.btnCrear_det  = true
      this.btnEditar_det = false
    },
    abrirModalEditar(idModuUsua){
      this.modalWindow = true
      if(idModuUsua != null){    
           api.get('/vwmoduusuas/'+idModuUsua).then(resp=>{
          this.datoModuUsua = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar Módulos'
      this.btnCrear_det  = false
      this.btnEditar_det = true
    },
    abrirEditarDet(idModuUsua){
      this.modalWindow = true
      if(idModuUsua != null){
        this.$router.push('/moduusuamd/'+idModuUsua)
      }
    },
    async deleteModuUsua (idModuUsua) {
      try{
        await api.delete('/moduusuas/'+idModuUsua)
          this.getModuUsuas()
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
// Procedimientos detalle
// Listas de valores master
// Listas de valores master
// Listas de valores details
//    Lista de Valores
    GetDataModuUsuaLOVdet(data) {
      this.datoModuUsua.idModuUsua = data.idModuUsua;
      this.datoModuUsua.moduUsua = data.nombre;
    },
//    Lista de Valores
    GetDataRolLOVdet(data) {
      this.datoModuUsua.idRol = data.idRol;
      this.datoModuUsua.rol = data.nombre;
    },
// Listas de valores details
  },
}
</script>
